var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Input from '.';
var InputNum = function (props) {
    var error = props.error, helperText = props.helperText, onChange = props.onChange, other = __rest(props, ["error", "helperText", "onChange"]);
    var _a = useState(''), message = _a[0], setMessage = _a[1];
    return (React.createElement(Input, __assign({}, other, { error: error || message.length > 0, helperText: message || helperText, onChange: function (e) {
            var value = e.target.value;
            if (value.length > 0 && Number.isNaN(Number(value))) {
                setMessage('請輸入數字。');
                return;
            }
            setMessage('');
            if (onChange) {
                onChange(e);
            }
        } })));
};
export default InputNum;
